import { alpha, Theme } from '@mui/material/styles';

export const homeStyles = (theme: Theme, isDark: boolean) => ({
  backButton: {
    position: 'fixed',
    bottom: 24,
    right: 24
  },
  container: {
    width: '100vw',
    minHeight: '100vh',
    boxSizing: 'border-box',
    height: 'auto',
    backgroundSize: '100%',
    backgroundColor: isDark ? '#000016' : theme.palette.background.default,
    background: isDark
      ? `radial-gradient(circle at 25% 20%, ${alpha(
          theme.palette.primary.main,
          0.5
        )} 3%, #000016 28%, transparent),radial-gradient(circle at 65% 75%, ${alpha(
          theme.palette.primary.main,
          0.47
        )} 2%, #000016 35%) `
      : `radial-gradient(circle at 25% 20%, ${alpha(
          theme.palette.primary.main,
          0.3
        )} 3%, #E9F0FD 28%, transparent),radial-gradient(circle at 70% 80%, ${alpha(
          theme.palette.primary.main,
          0.45
        )} 2%, #E9F0FD 40%) `,
    backgroundRepeat: 'no-repeat',
    position: 'relative',

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  }
});
